import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
//import { GetCommonBaseURL } from '../axiosComponent/read';
import AxiosRequest from "../axiosComponent/allAxiosCommonRequest";

const MyCategory = ({ field: { name }, form: { setFieldValue }, ...props }) => {
  const [content, setcontent] = useState([]);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    // $("#searchType .dropdown").removeClass("dropdown")
    setloading(true);
    AxiosRequest({
      url: "masters/service_category",
      method: "get",
    }) //CommonGetApi({ url: 'branch' })
      .then((data) => {
        let result = data.data?.resultSet
        if(result?.length && props.restrictCategoryId){
          result = result.filter((res)=> props.restrictCategoryId != res.serviceCategoryId)
        }
        setcontent(result);
        setloading(false);
      })
      .catch((error) => console.log(error));
    /* GetCommonBaseURL({
            newUrl: 'masters/service_category',
            response: ((data) => {
                setcontent(data.data.resultSet)
                setloading(false)
            })
        }) */
  }, [props?.restrictCategoryId]);
  let options = [];
  if (content.length > 0) {
    content.map((object, index) => {
      let temp = {};
      temp.key = object.serviceCategoryId;
      temp.text = `${object.serviceCategory}`;
      temp.value = props.idValue ? object.serviceCategoryId : object.serviceCategoryCode;
      return (options[index] = temp);
    });
  }
  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
  };
  return (
    <Dropdown
      selection
      search
      scrolling
      loading={loading ? true : false}
      style={{ width: "100%" }}
      onChange={handleChange}
      options={options}
      // id="searchType"
      noResultsMessage="Search for Result"
      {...props}
    />
  );
};

export default MyCategory;
